import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "cross-sm",
  "use": "cross-sm-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"cross-sm\"><path d=\"M7.793 8.5L5.146 5.854a.5.5 0 11.708-.708L8.5 7.793l2.646-2.647a.5.5 0 01.708.708L9.207 8.5l2.647 2.646a.5.5 0 01-.708.708L8.5 9.207l-2.646 2.647a.5.5 0 01-.708-.708L7.793 8.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol